import React, {useEffect} from 'react';
// import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const MetaTags = (title = '', description = ''): any => {
    const location = useLocation();
    // Получаем текущий путь
    const currentUrl = window.location.origin + location.pathname; // Получаем текущий URL
    useEffect(() => {
        document.title = title;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", description);
        }
        const relCanonical = document.querySelector('link[rel="canonical"]');
        if (relCanonical) {
            relCanonical.setAttribute("href", currentUrl);
        }
    }, []); // Пустой массив зависимостей означает, что эффект выполнится только один раз при монтировании компонента

    return null;
};

export default MetaTags;

